import { z } from 'zod';
/**
 * Severidade de um achado do validador.
 *
 *  - `IMPEDITIVO` — o ato não pode ser gerado. Trava. Ex.: soma de quotas
 *    diferente do capital, CPF inválido, SLU com dois sócios.
 *  - `EXIGENCIA`  — sai, mas a Junta muito provavelmente devolve. Ex.: norma
 *    revogada citada, enquadramento incoerente.
 *  - `AVISO`      — não impede nada, mas é sinal de copy-paste. Ex.: CEP em
 *    dois formatos no mesmo documento.
 *
 * A separação existe para o validador poder ser rígido sem ser inútil: travar
 * tudo faz o contador voltar para o Word.
 */
export const severidadeSchema = z.enum(['IMPEDITIVO', 'EXIGENCIA', 'AVISO']);
export const achadoSchema = z.object({
    /** Identificador estável da regra, kebab-case. Entra em relatório e métrica. */
    regra: z.string().min(3),
    severidade: severidadeSchema,
    /** Caminho do campo no estado, quando aplicável: `socios[0].quotas`. */
    campo: z.string().nullable().default(null),
    /** Frase para o contador ler. Diz o que está errado, não o que a regra faz. */
    mensagem: z.string().min(10),
    /** Trecho do documento que provocou o achado, quando veio de auditoria. */
    trecho: z.string().nullable().default(null),
    /** Base legal ou normativa, quando existe. Ex.: `art. 1.052 CC`. */
    fundamento: z.string().nullable().default(null),
});
export const ORDEM_SEVERIDADE = {
    IMPEDITIVO: 0,
    EXIGENCIA: 1,
    AVISO: 2,
};
/** Ordena do mais grave para o menos grave, estável dentro da mesma severidade. */
export function ordenarAchados(achados) {
    return [...achados].sort((a, b) => ORDEM_SEVERIDADE[a.severidade] - ORDEM_SEVERIDADE[b.severidade]);
}
export function temImpeditivo(achados) {
    return achados.some((a) => a.severidade === 'IMPEDITIVO');
}
//# sourceMappingURL=achado.js.map